import { Themed } from "@client/styles/themes";
import React from "react";
import { VisuallyHidden, usePreventScroll } from "react-aria";

import { HeaderMenu } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ButtonPrimary, Clickable } from "../Clickables";

import styles from "./nav-popover.module.scss";

interface Props {
    menu: HeaderMenu;
    menuId: string;
    mobileDesign: boolean;
    setActiveMenu: (menuId: string | null) => void;
}

interface CustomCSS extends React.CSSProperties {
    "--items": number;
}

export const NavPopover = ({
    menu,
    menuId,
    mobileDesign,
    setActiveMenu,
}: Props) => {
    usePreventScroll({ isDisabled: false });

    const items = menu.items || [];

    return (
        <>
            <Themed
                theme="robinsBlue"
                className={concatClassNames([
                    mobileDesign ? styles.mobilePopover : styles.popover,
                ])}
                id={menuId}
            >
                <ul
                    className={
                        mobileDesign ? styles.l2ListMobile : styles.l2List
                    }
                    style={{ "--items": items.length } as CustomCSS}
                >
                    {items.map((item) => {
                        const menuItem = item.value;
                        const image = menuItem.image;
                        const link = menuItem.link;

                        const innards = (
                            <>
                                {image && (
                                    <ImageChooserBlock
                                        value={image}
                                        attrs={{
                                            className: styles.itemPicture,
                                        }}
                                        imageAttrs={{ alt: "" }}
                                        sizes={mobileDesign ? "50vw" : "20vw"}
                                    />
                                )}
                                {link?.display_name && (
                                    <div className={styles.itemTitle}>
                                        {link.display_name}
                                    </div>
                                )}
                            </>
                        );

                        return (
                            <li key={item.id}>
                                {link?.url ? (
                                    <Clickable href={link.url}>
                                        {innards}
                                    </Clickable>
                                ) : (
                                    innards
                                )}
                            </li>
                        );
                    })}
                </ul>
                {menu.cta?.url && (
                    <ButtonPrimary href={menu.cta.url}>
                        {menu.cta.display_name}
                    </ButtonPrimary>
                )}
            </Themed>
            <Clickable
                className={!mobileDesign ? styles.underlay : ""}
                onPress={() => setActiveMenu(null)}
                onMouseEnter={() => {
                    if (!mobileDesign) setActiveMenu(null);
                }}
            >
                <VisuallyHidden>Close Nav Menu</VisuallyHidden>
            </Clickable>
        </>
    );
};
